<template>
  <div class="how-keep-low-prices pb-16">
    <SectionHeader class="mb-8 lg:mb-12 px-6 md:px-8">
      <template #header>
        <div class="text-left md:text-center">How We Keep Prices So Low</div>
      </template>
      <template #subheader>
        <div class="text-left md:text-center">And keep quality high</div>
      </template>
    </SectionHeader>
    <div
      class="max-w-4xl mx-auto grid grid-cols-12 gap-0 gap-y-8 md:gap-8 lg:gap-12 px-6 md:px-8"
    >
      <div
        v-for="(item, index) in items"
        :key="`low-price-left-item-${index}`"
        class="col-span-12 md:col-span-6 lg:col-span-5 flex"
        :class="index === 0 || index === 2 ? 'col-start-1 lg:col-start-2' : ''"
      >
        <HighlightedIcon
          :icon="item.icon"
          class="w-12 h-12 flex-shrink-0 icon mr-6"
        />
        <div class="text-block">
          <TypeBody
            :variant="$options.Typography.Body.MEDIUM"
            :weight="$options.Typography.Weights.STRONG"
            tag="p"
            class="mb-2"
          >
            {{ item.title }}
          </TypeBody>
          <TypeBody
            :variant="$options.Typography.Body.MEDIUM"
            :weight="$options.Typography.Weights.REGULAR"
            tag="p"
          >
            {{ item.body }}
          </TypeBody>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { constants, HighlightedIcon, TypeBody } from '@bambeehr/pollen';
import SectionHeader from './SectionHeader';

const { Typography } = constants;

export default {
  name: 'HowKeepLowPrices',
  Typography,
  components: {
    HighlightedIcon,
    SectionHeader,
    TypeBody,
  },
  data() {
    return {
      items: [
        {
          icon: 'clipboardCheckSolid',
          title: 'Small Business Focused',
          body: 'We only service businesses with less than 500 employees. That means we deal with your types of needs all day, every day.',
        },
        {
          icon: 'doorOpenSolid',
          title: 'The Best of Modern Tech',
          body: 'We use cutting edge data technology to stay informed about labor laws & help you avoid mistakes.',
        },
        {
          icon: 'binoculars',
          title: 'HR Practice Automation',
          body: 'HR Autopilot automates your key HR practices to keep you HR compliant all year through.',
        },
      ],
    };
  },
};
</script>

<style scoped>
.text-block {
  max-width: 337px;
}

@media screen and (max-width: 1024px) {
  .text-block {
    max-width: none;
    width: 100%;
  }
}
</style>
